import { render, staticRenderFns } from "./InsurerForm.vue?vue&type=template&id=dc9219b4"
import script from "./InsurerForm.vue?vue&type=script&lang=js"
export * from "./InsurerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports